module.exports = __webpack_public_path__ + "img/MX_round.4f2276ad.png";